import React from "react";
import { getBugsnagReactPlugin } from "integrations/bugsnag";

const fallbackStyles = {
  padding: "48px 24px",
  textAlign: "center",
  fontFamily: "inherit",
};

const FallbackView = () => (
  <div style={fallbackStyles}>
    Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu.
  </div>
);

const AppErrorBoundary = ({ children }) => {
  const plugin = getBugsnagReactPlugin();
  if (!plugin) {
    return <>{children}</>;
  }

  const ErrorBoundary = plugin.createErrorBoundary(React);
  if (!ErrorBoundary) {
    return <>{children}</>;
  }

  const shouldShowFallback = import.meta.env.VITE_ENV !== "development";

  return (
    <ErrorBoundary
      FallbackComponent={shouldShowFallback ? FallbackView : undefined}
    >
      {children}
    </ErrorBoundary>
  );
};

export default AppErrorBoundary;

